import React from 'react'
import { CarouselProvider, Slider, ButtonBack, ButtonNext, DotGroup } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.cjs.css'
import { useIsXs } from 'hooks/responsive'
import { ReactComponent as CaretRight } from 'resources/svg/icons/caret-right.svg'
import { ReactComponent as CaretLeft } from 'resources/svg/icons/caret-left.svg'
import { ReactComponent as AngleLeft } from 'resources/svg/icons/chevron-left.svg'
import { ReactComponent as AngleRight } from 'resources/svg/icons/chevron-right.svg'
import { Header, ArrowContainer, Container } from './components/Styled'
import { CircularProgress } from './components/CircularProgress'

interface SliderProps {
  title?: string
  child: any[]
  renderChildren: (children: any[]) => React.ReactNode
  visibleSlides?: number
  arrowsEnabled?: boolean
  autoPlay?: boolean
  dotsEnabled?: boolean
  slideHeight?: number
  slideWidth?: number
  autoHeight?: boolean
  isPromo?: boolean
  interval?: number
  fadeSides?: boolean
}

export const Carousel: React.FC<SliderProps> = ({
  title,
  child,
  renderChildren,
  visibleSlides = 1,
  arrowsEnabled = true,
  dotsEnabled = false,
  autoPlay,
  slideHeight = 1000,
  slideWidth = 400,
  autoHeight,
  isPromo,
  interval = 5000,
  fadeSides= false
}) => {
  const isMobile = useIsXs()
  return (
    <Container isPromo={isPromo} fadeSides={fadeSides}>
      {title && (
        <Header>
          <h2>{title}</h2>
        </Header>
      )}
      <CarouselProvider
        visibleSlides={visibleSlides}
        totalSlides={child.length}
        naturalSlideHeight={slideHeight}
        naturalSlideWidth={slideWidth}
        isPlaying={autoPlay}
        isIntrinsicHeight={autoHeight}
        infinite
        interval={interval}
      >
        {arrowsEnabled && (
          <ArrowContainer
            className='carousel__arrows'
            isPromo={isPromo}
          >
            <ButtonBack>
              {!isPromo ? <CaretLeft /> : <AngleLeft />}
            </ButtonBack>
            {isPromo && !isMobile && (
              <div className='progress'>
                <CircularProgress
                  interval={interval}
                />
              </div>
            )}
            <ButtonNext>
              {!isPromo ? <CaretRight /> : <AngleRight />}
            </ButtonNext>
          </ArrowContainer>
        )}
        <Slider>
          {renderChildren(child)}
        </Slider>
        {dotsEnabled && (
          <DotGroup />
        )}
      </CarouselProvider>
    </Container>
  )
}
